import { api } from 'api';
import { requestErrorAction } from 'common/utils/requestErrorHandling';
import { UserInformation } from './actions';

interface LoginResponse {
  username: string;
}

export const doLogin =
  (username: string, password: string) => async (dispatch) => {
    dispatch({ type: 'auth/started' });

    try {
      await api.post<LoginResponse>('/login/', {
        username,
        password,
      });
      dispatch(doInitSession());
    } catch (e) {
      dispatch(
        requestErrorAction({ type: 'auth/finished' }, e, `Failed to login.`)
      );
    }
  };

export const doInitSession = () => async (dispatch) => {
  try {
    const response = await api.get<UserInformation>('/contact/self/');
    dispatch({ type: 'auth/finished', user: response.data });
  } catch (e) {
    dispatch(
      requestErrorAction({ type: 'auth/finished' }, e, `Failed to login.`)
    );
  }
};

export const doLogout = () => async (dispatch) => {
  await api.post<LoginResponse>('/logout/', null);
  dispatch({ type: 'auth/finished', user: null });
};

interface RecoverResponse {
  success: string;
}

export const doRecover = (username_or_email: string) => async (dispatch) => {
  dispatch({ type: 'recover/started' });

  try {
    await api.post<RecoverResponse>('/recover_password/', {
      username_or_email,
    });
    dispatch({
      type: 'recover/finished',
      outcome: 'Success',
    });
  } catch {
    dispatch({
      type: 'recover/finished',
      error: 'Recovery failed',
    });
  }
};
